// extracted by mini-css-extract-plugin
export var footer = "_q1-0";
export var inherit = "_q1-1";
export var input = "_q1-2";
export var modalContent = "_q1-3";
export var quillEditor = "_q1-4";
export var subtitle = "_q1-5";